function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw new Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw new Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React from "react";
import moment from "moment-timezone";
import { FilterContext } from "../index";
import Loader from "./../Loader/Loader";
import { useTable, useSortBy } from "react-table";
import Dropdown from "react-bootstrap/Dropdown";
import Button from "react-bootstrap/Button";
import classNames from "classnames";
import "./ManualTimeReport.css";
import { HiDownload, HiOutlineSelector, HiChevronDown, HiChevronUp } from "react-icons/hi";
import { GET_MANUAL_LISTING_QUERY, GET_MANUAL_LISTING_EXPORT_QUERY } from "./query";
import { useQuery, useLazyQuery } from "@apollo/client";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import Excel from "exceljs/dist/es5/exceljs.browser";
import { saveAs } from "file-saver";
// import { USER_LISTING_QUERY } from "./../ManualPages/query";
import { GET_USER_LISTING_QUERY } from "./../MonthlyAttendance/query";
import { MultiSelect } from "react-multi-select-component";
import { TimeFilter } from "./../ProjectReport/DateFilter";
import { arrayToStringOutput } from "./../SideMenu/Header";
import Select from "react-select";
var LIMIT = 20;
var offsets = 0;
var ManualTimeReport = function ManualTimeReport(props) {
  var _React$useContext = React.useContext(FilterContext),
    organisationId = _React$useContext.organisationId,
    organisationSettings = _React$useContext.organisationSettings,
    role = _React$useContext.role,
    organisationBilling = _React$useContext.organisationBilling,
    from = _React$useContext.from,
    teamId = _React$useContext.teamId,
    organisationStatus = _React$useContext.organisationStatus;
  var currentTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

  //  WORKFOLIO MAINTENANCE REDIRECTION
  // React.useEffect(() => {
  //   props?.history.push("/workfolio-maintenance");
  // }, []);

  var currentSystemOffset = moment.tz(currentTimezone).utcOffset();
  var organisationSystemOffset = organisationSettings !== null && organisationSettings !== void 0 && organisationSettings.organisationTimezone ? moment.tz(organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.organisationTimezone).utcOffset() : 0;
  var _React$useState = React.useState({
      startDate: currentSystemOffset < 0 && organisationSystemOffset > 0 || currentSystemOffset < 0 && organisationSystemOffset < 0 && currentSystemOffset < organisationSystemOffset || currentSystemOffset < 0 && organisationSystemOffset < 0 && currentSystemOffset == organisationSystemOffset ? moment().tz(currentTimezone).clone().startOf("day").toDate() : currentSystemOffset > 0 && organisationSystemOffset < 0 || currentSystemOffset > 0 && organisationSystemOffset < 0 && currentSystemOffset - Math.abs(organisationSystemOffset) < 0 || currentSystemOffset > 0 && organisationSystemOffset > 0 && currentSystemOffset > organisationSystemOffset ? moment().tz(currentTimezone).clone().endOf("days").toDate() : moment().tz(currentTimezone).clone().toDate(),
      endDate: null
    }),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    dates = _React$useState2[0],
    setDate = _React$useState2[1];
  var _React$useState3 = React.useState(false),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    isAllLoaded = _React$useState4[0],
    setIsAllLoaded = _React$useState4[1];
  var _React$useState5 = React.useState(false),
    _React$useState6 = _slicedToArray(_React$useState5, 2),
    isLoadingMore = _React$useState6[0],
    setIsLoadingMore = _React$useState6[1];
  var _React$useState7 = React.useState([]),
    _React$useState8 = _slicedToArray(_React$useState7, 2),
    userParameterCheck = _React$useState8[0],
    setUserParameterCheck = _React$useState8[1];
  var _React$useState9 = React.useState([]),
    _React$useState10 = _slicedToArray(_React$useState9, 2),
    projectParameterCheck = _React$useState10[0],
    setProjectParameterCheck = _React$useState10[1];
  var _React$useState11 = React.useState(null),
    _React$useState12 = _slicedToArray(_React$useState11, 2),
    statusParameterCheck = _React$useState12[0],
    setStatusParameterCheck = _React$useState12[1];
  var _React$useState13 = React.useState(false),
    _React$useState14 = _slicedToArray(_React$useState13, 2),
    exportButton = _React$useState14[0],
    setExportButton = _React$useState14[1];
  var _React$useState15 = React.useState(false),
    _React$useState16 = _slicedToArray(_React$useState15, 2),
    isNavClick = _React$useState16[0],
    setNavClick = _React$useState16[1];
  var _React$useState17 = React.useState([]),
    _React$useState18 = _slicedToArray(_React$useState17, 2),
    userActive = _React$useState18[0],
    setUserActive = _React$useState18[1];
  var _React$useState19 = React.useState([]),
    _React$useState20 = _slicedToArray(_React$useState19, 2),
    projectActive = _React$useState20[0],
    setProjectActive = _React$useState20[1];
  var startDate = dates.startDate,
    endDate = dates.endDate;
  var filterData = arrayToStringOutput([startDate, endDate], organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.organisationTimezone);
  var userList = [];
  var projectList = [];
  React.useEffect(function () {
    if (from == "web" && role == "Member" && organisationSettings !== null && organisationSettings !== void 0 && organisationSettings.allowMemberToAccessTimesheet) {
      props === null || props === void 0 ? void 0 : props.history.push("/timesheet");
    }
    if (from == "web" && role == "Member" && organisationSettings !== null && organisationSettings !== void 0 && organisationSettings.manualTimeFeature) {
      props === null || props === void 0 ? void 0 : props.history.push("/manual-time");
    }
  }, [role]);
  React.useEffect(function () {
    if (((organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.planId) == null || (organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.planStatus) === "stopped") && role != "Member" || organisationStatus == "inactive") {
      props === null || props === void 0 ? void 0 : props.history.push("/billing");
    }
  }, [organisationBilling]);
  React.useEffect(function () {
    offsets = 0;
  }, [startDate]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "report-app-usage-root"
  }, /*#__PURE__*/React.createElement(FilterHeaderView, {
    userList: userList,
    userParameterCheck: userParameterCheck,
    setUserParameterCheck: setUserParameterCheck,
    projectList: projectList,
    projectParameterCheck: projectParameterCheck,
    setProjectParameterCheck: setProjectParameterCheck,
    isNavClick: isNavClick,
    startDate: startDate,
    endDate: endDate,
    setDate: setDate,
    filterData: filterData,
    organisationBilling: organisationBilling,
    exportButton: exportButton,
    projectActive: projectActive,
    userActive: userActive,
    organisationSettings: organisationSettings,
    organisationId: organisationId,
    setExportButton: setExportButton,
    teamId: teamId,
    from: props === null || props === void 0 ? void 0 : props.from,
    setUserActive: setUserActive,
    setProjectActive: setProjectActive,
    statusParameterCheck: statusParameterCheck,
    setStatusParameterCheck: setStatusParameterCheck,
    role: role
  }), /*#__PURE__*/React.createElement(ReportTable, {
    organisationId: organisationId,
    userActive: userActive,
    startDate: startDate,
    endDate: endDate,
    organisationSettings: organisationSettings,
    projectActive: projectActive,
    setIsAllLoaded: setIsAllLoaded,
    isAllLoaded: isAllLoaded,
    setIsLoadingMore: setIsLoadingMore,
    isLoadingMore: isLoadingMore,
    statusParameterCheck: statusParameterCheck
  })));
};
var FilterHeaderView = function FilterHeaderView(props) {
  var _userListData$getUser;
  var userList = props.userList,
    userParameterCheck = props.userParameterCheck,
    setUserParameterCheck = props.setUserParameterCheck,
    projectList = props.projectList,
    projectParameterCheck = props.projectParameterCheck,
    setProjectParameterCheck = props.setProjectParameterCheck,
    isNavClick = props.isNavClick,
    startDate = props.startDate,
    endDate = props.endDate,
    setDate = props.setDate,
    filterData = props.filterData,
    organisationBilling = props.organisationBilling,
    exportButton = props.exportButton,
    projectActive = props.projectActive,
    organisationSettings = props.organisationSettings,
    userActive = props.userActive,
    organisationId = props.organisationId,
    setExportButton = props.setExportButton,
    teamId = props.teamId,
    from = props.from,
    setUserActive = props.setUserActive,
    setProjectActive = props.setProjectActive,
    statusParameterCheck = props.statusParameterCheck,
    setStatusParameterCheck = props.setStatusParameterCheck,
    role = props.role;
  var _useQuery = useQuery(GET_USER_LISTING_QUERY, {
      variables: {
        organisationId: organisationId,
        teamId: teamId,
        userRole: role
      },
      skip: !teamId || !organisationId
    }),
    userListData = _useQuery.data,
    userListError = _useQuery.error,
    userListLoading = _useQuery.loading;

  // const {
  //   data: projectsListingForFilter,
  //   error: projectListingFilterError,
  //   loading: projectListingFilterLoading,
  // } = useQuery(PROJECTS_LISTING_FOR_FILTER_QUERY, {
  //   variables: {
  //     organisationId,
  //     teamId: "all",
  //     from: from ? "desktop" : null,
  //   },
  //   skip: !organisationId || !teamId,
  // });

  var _useLazyQuery = useLazyQuery(GET_MANUAL_LISTING_EXPORT_QUERY, {
      // A rate-limited export (429) never returns data, and this screen's
      // spinner is cleared on data only - without this the export button
      // stays loading until the page is reloaded. The message itself is
      // shown by the errorLink in apollo/apollo-config.js.
      onError: function onError() {
        setExportButton(false);
      }
    }),
    _useLazyQuery2 = _slicedToArray(_useLazyQuery, 2),
    getExport = _useLazyQuery2[0],
    _useLazyQuery2$ = _useLazyQuery2[1],
    exportLoading = _useLazyQuery2$.loading,
    exportData = _useLazyQuery2$.data;
  var statusList = [{
    label: "All",
    value: null
  }, {
    label: "Approved",
    value: "approved"
  }, {
    label: "Rejected",
    value: "rejected"
  }, {
    label: "Pending",
    value: "pending"
  }];
  var csvData = React.useCallback( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
    var exportDatas, wb, ws, buf, fileName;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          exportDatas = exportData === null || exportData === void 0 ? void 0 : exportData.getManualTaskDetailsReportExport;
          if (exportDatas) {
            _context.next = 3;
            break;
          }
          return _context.abrupt("return", []);
        case 3:
          wb = new Excel.Workbook();
          ws = wb.addWorksheet();
          ws.columns = [{
            header: "Employee",
            key: "displayName",
            width: 20,
            style: {
              alignment: {
                vertical: "middle",
                horizontal: "left"
              }
            }
          }, {
            header: "Date",
            key: "taskDate",
            style: {
              alignment: {
                vertical: "middle",
                horizontal: "left"
              }
            }
          }, {
            header: "Task description",
            key: "taskDescription",
            width: 20,
            style: {
              alignment: {
                vertical: "middle",
                horizontal: "left"
              }
            }
          }, {
            header: "Start & End time",
            key: "time",
            style: {
              alignment: {
                vertical: "middle",
                horizontal: "left"
              }
            }
          }, {
            header: "Duration",
            key: "totalHours",
            style: {
              alignment: {
                vertical: "middle",
                horizontal: "left"
              }
            }
          }, {
            header: "Review Status",
            key: "status",
            style: {
              alignment: {
                vertical: "middle",
                horizontal: "left"
              }
            }
          }];
          exportDatas.map(function (d, index) {
            var user = d.user,
              taskDescription = d.taskDescription,
              startTime = d.startTime,
              endTime = d.endTime,
              totalHours = d.totalHours,
              taskDate = d.taskDate,
              reviewStatus = d.reviewStatus,
              reviewedName = d.reviewedName;
            ws.addRow({
              time: "".concat(startTime, " - ").concat(endTime),
              totalHours: totalHours,
              taskDescription: taskDescription,
              displayName: user.displayName,
              taskDate: moment(taskDate).format("DD MMM YYYY"),
              status: reviewStatus != null ? "".concat(reviewStatus, " by ").concat(reviewedName) : "pending"
            });
          });
          ws.getCell("A1").font = {
            bold: true
          };
          ws.getCell("B1").font = {
            bold: true
          };
          ws.getCell("C1").font = {
            bold: true
          };
          ws.getCell("D1").font = {
            bold: true
          };
          ws.getCell("E1").font = {
            bold: true
          };
          ws.getCell("F1").font = {
            bold: true
          };
          _context.next = 15;
          return wb.xlsx.writeBuffer();
        case 15:
          buf = _context.sent;
          fileName = "workfolio-manual-time-".concat(moment(Number(startDate)).format("DD-MMM"), ".xlsx");
          if (endDate != null) {
            fileName = "workfolio-manual-time-".concat(moment(Number(startDate)).format("DD-MMM"), "-").concat(moment(Number(endDate)).format("DD-MMM"), ".xlsx");
          }
          saveAs(new Blob([buf]), fileName);
          setExportButton(false);
        case 20:
        case "end":
          return _context.stop();
      }
    }, _callee);
  })), [exportData]);
  React.useEffect(function () {
    csvData();
  }, [exportData]);
  userListData === null || userListData === void 0 ? void 0 : (_userListData$getUser = userListData.getUserListing) === null || _userListData$getUser === void 0 ? void 0 : _userListData$getUser.map(function (item) {
    var userId = item.userId,
      displayName = item.displayName;
    return userList.push({
      label: displayName,
      value: userId
    });
  });
  // projectsListingForFilter?.projectsListingForFilter?.projects.map((item) => {
  //   const { projectName, projectId } = item;
  //   return projectList.push({
  //     label: projectName,
  //     value: projectId,
  //   });
  // });

  // React.useEffect(() => {
  //   const data = [];
  //   projectsListingForFilter?.projectsListingForFilter?.projects.map((item) => {
  //     const { projectName, projectId } = item;
  //     return data.push({
  //       label: projectName,
  //       value: projectId,
  //     });
  //   });
  //   if (
  //     projectsListingForFilter?.projectsListingForFilter?.projects.length &&
  //     projectActive.length == 0 &&
  //     projectParameterCheck.length == 0
  //   ) {
  //     setProjectParameterCheck(data);
  //   }
  // }, [projectsListingForFilter]);

  React.useEffect(function () {
    var _userListData$getUser2;
    var data = [];
    userListData === null || userListData === void 0 ? void 0 : (_userListData$getUser2 = userListData.getUserListing) === null || _userListData$getUser2 === void 0 ? void 0 : _userListData$getUser2.map(function (item) {
      var userId = item.userId,
        displayName = item.displayName;
      return data.push({
        label: displayName,
        value: userId
      });
    });
    if (userListData !== null && userListData !== void 0 && userListData.getUserListing.length && userActive.length == 0 && userParameterCheck.length == 0) {
      setUserParameterCheck(data);
    }
  }, [userListData]);
  React.useEffect(function () {
    var selectedUserIds = userParameterCheck === null || userParameterCheck === void 0 ? void 0 : userParameterCheck.map(function (user) {
      return user.value;
    });
    setUserActive(selectedUserIds);
  }, [userParameterCheck]);

  // React.useEffect(() => {
  //   const selectedProjectIds = projectParameterCheck?.map((user) => user.value);
  //   setProjectActive(selectedProjectIds);
  // }, [projectParameterCheck]);

  if (userListLoading) {
    return /*#__PURE__*/React.createElement(Loader, null);
  }
  if (userListError) {
    return /*#__PURE__*/React.createElement("div", {
      className: "common-err-refresh-text"
    }, "Something went wrong, please refresh the page.");
  }
  if (!userListData) {
    return null;
  }
  var getExportData = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            setExportButton(true);
            getExport({
              variables: {
                organisationId: organisationId,
                userId: userActive.length ? userActive : null,
                startDate: Number(moment(startDate).startOf("day").format("x")),
                endDate: Number(moment(endDate !== null && endDate !== void 0 ? endDate : startDate).endOf("day").format("x")),
                timeZone: organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.organisationTimezone,
                projectId: projectActive.length ? projectActive : null
              }
            });
          case 2:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function getExportData() {
      return _ref2.apply(this, arguments);
    };
  }();
  var onFilterChange = function onFilterChange(dates) {
    setDate(dates);
  };
  var hideOverlay = function hideOverlay() {
    var _document, _document$body, _document$body$click;
    (_document = document) === null || _document === void 0 ? void 0 : (_document$body = _document.body) === null || _document$body === void 0 ? void 0 : (_document$body$click = _document$body.click) === null || _document$body$click === void 0 ? void 0 : _document$body$click.call(_document$body);
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "manual-time-report-filter-root"
  }, /*#__PURE__*/React.createElement("div", {
    className: "manual-time-report-filter-content"
  }, /*#__PURE__*/React.createElement("div", {
    className: "manual-time-report-filter-user"
  }, /*#__PURE__*/React.createElement(MultiSelect, {
    options: userList,
    value: userParameterCheck,
    onChange: function onChange(e) {
      setUserParameterCheck(e);
    },
    overrideStrings: {
      allItemsAreSelected: "All Members",
      selectAll: "All Members",
      selectSomeItems: "Select a user"
    }
  })), /*#__PURE__*/React.createElement(Dropdown, {
    open: isNavClick,
    className: classNames("manual-time-report-users-button .btn-primary")
  }, /*#__PURE__*/React.createElement(Dropdown.Toggle, {
    id: "dropdown-basics"
  }, arrayToStringOutput([startDate, endDate], organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.organisationTimezone)), /*#__PURE__*/React.createElement(Dropdown.Menu, {
    className: "page-content-wrapper-menu-filter-overlay-trigger"
  }, /*#__PURE__*/React.createElement(TimeFilter, {
    onFilterChange: onFilterChange,
    startDate: startDate,
    endDate: endDate,
    filterData: filterData,
    onClose: hideOverlay,
    organisationBilling: organisationBilling,
    organisationSettings: organisationSettings
  }))), /*#__PURE__*/React.createElement(Select, {
    value: statusParameterCheck,
    onChange: function onChange(e) {
      return setStatusParameterCheck(e);
    },
    options: statusList,
    className: "manual-time-report-details-filter-user-select"
    //styles={customStyles}
    ,
    classNamePrefix: "Filter By User"
    //isMulti
  })), /*#__PURE__*/React.createElement("div", null, (organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.planName) != "free" ? !exportButton ? /*#__PURE__*/React.createElement(Button, {
    variant: "outline-primary",
    onClick: function onClick() {
      getExportData();
    },
    className: "daily-attendance-filter-download-icon-btn"
  }, /*#__PURE__*/React.createElement(HiDownload, {
    className: "daily-attendance-filter-download-icon"
  }), " Export") : /*#__PURE__*/React.createElement(Button, {
    variant: "outline-primary",
    className: "daily-attendance-filter-download-icon-btn"
  }, /*#__PURE__*/React.createElement(HiDownload, {
    className: "daily-attendance-filter-download-icon"
  }), "Downloading") : /*#__PURE__*/React.createElement(OverlayTrigger, {
    placement: "bottom",
    overlay: /*#__PURE__*/React.createElement(Tooltip, {
      id: "tooltip-bottom",
      className: "count-tooltip-start"
    }, "Please upgrade your plan to export report")
  }, /*#__PURE__*/React.createElement("div", {
    className: "timesheet-export-button-header disable-timesheet"
  }, /*#__PURE__*/React.createElement(HiDownload, {
    className: "timesheet-download-icon"
  }), " Export"))));
};
var ReportTable = function ReportTable(props) {
  var _manualTimeData$getMa, _manualTimeData$getMa2, _manualTimeData$getMa3, _manualTimeData$getMa4;
  var organisationId = props.organisationId,
    userActive = props.userActive,
    startDate = props.startDate,
    endDate = props.endDate,
    organisationSettings = props.organisationSettings,
    projectActive = props.projectActive,
    setIsAllLoaded = props.setIsAllLoaded,
    isAllLoaded = props.isAllLoaded,
    isLoadingMore = props.isLoadingMore,
    setIsLoadingMore = props.setIsLoadingMore,
    statusParameterCheck = props.statusParameterCheck;
  var _useQuery2 = useQuery(GET_MANUAL_LISTING_QUERY, {
      variables: {
        organisationId: organisationId,
        userId: userActive.length ? userActive : null,
        startDate: Number(moment(startDate).startOf("day").format("x")),
        endDate: Number(moment(endDate !== null && endDate !== void 0 ? endDate : startDate).endOf("day").format("x")),
        timeZone: organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.organisationTimezone,
        limit: LIMIT,
        offset: 0,
        projectId: projectActive.length ? projectActive : null,
        reviewStatus: statusParameterCheck ? statusParameterCheck.value : statusParameterCheck
      },
      skip: !organisationId
    }),
    manualTimeData = _useQuery2.data,
    manualTimeError = _useQuery2.error,
    manualTimeLoading = _useQuery2.loading,
    fetchMore = _useQuery2.fetchMore,
    manualTimeRefetch = _useQuery2.refetch;
  var columns = React.useMemo(function () {
    return [{
      Header: "Employee",
      accessor: "displayName"
    }, {
      Header: "Date",
      accessor: "taskDate"
    }, {
      Header: "Task description",
      accessor: "taskDescription"
    }, {
      Header: "Start & End time",
      accessor: "time"
    }, {
      Header: "Duration",
      accessor: "totalHours"
    }, {
      Header: "Review Status",
      accessor: "status"
    }];
  }, []);
  React.useEffect(function () {
    manualTimeRefetch === null || manualTimeRefetch === void 0 ? void 0 : manualTimeRefetch();
  }, [location.key]);
  var dataTable = manualTimeData === null || manualTimeData === void 0 ? void 0 : (_manualTimeData$getMa = manualTimeData.getManualTaskDetailsReport) === null || _manualTimeData$getMa === void 0 ? void 0 : _manualTimeData$getMa.map(function (d) {
    var user = d.user,
      taskDescription = d.taskDescription,
      startTime = d.startTime,
      endTime = d.endTime,
      totalHours = d.totalHours,
      taskDate = d.taskDate,
      reviewStatus = d.reviewStatus,
      reviewedName = d.reviewedName;
    return {
      time: "".concat(startTime, " - ").concat(endTime),
      totalHours: totalHours,
      taskDescription: taskDescription,
      displayName: user.displayName,
      taskDate: moment(taskDate).format("DD MMM YYYY"),
      status: reviewStatus != null ? "".concat(reviewStatus, " by ").concat(reviewedName) : "pending"
    };
  });
  if ((manualTimeData === null || manualTimeData === void 0 ? void 0 : (_manualTimeData$getMa2 = manualTimeData.getManualTaskDetailsReport) === null || _manualTimeData$getMa2 === void 0 ? void 0 : _manualTimeData$getMa2.length) !== 0 && (manualTimeData === null || manualTimeData === void 0 ? void 0 : (_manualTimeData$getMa3 = manualTimeData.getManualTaskDetailsReport) === null || _manualTimeData$getMa3 === void 0 ? void 0 : _manualTimeData$getMa3.length) < LIMIT && !isAllLoaded) {
    setIsAllLoaded(true);
  }
  var handleLoadMore = function handleLoadMore() {
    if (manualTimeLoading) return;
    setIsLoadingMore(true);
    offsets = offsets + 1;
    fetchMore({
      variables: {
        offset: offsets * LIMIT
      },
      updateQuery: function updateQuery(prev, _ref3) {
        var _fetchMoreResult$getM, _fetchMoreResult$getM2;
        var fetchMoreResult = _ref3.fetchMoreResult;
        if (!fetchMoreResult) return prev;
        if ((fetchMoreResult === null || fetchMoreResult === void 0 ? void 0 : (_fetchMoreResult$getM = fetchMoreResult.getManualTaskDetailsReport) === null || _fetchMoreResult$getM === void 0 ? void 0 : _fetchMoreResult$getM.length) === 0 && ((_fetchMoreResult$getM2 = fetchMoreResult.getManualTaskDetailsReport) === null || _fetchMoreResult$getM2 === void 0 ? void 0 : _fetchMoreResult$getM2.length) < LIMIT && !isAllLoaded) {
          setIsAllLoaded(true);
        }
        setIsLoadingMore(false);
        return _objectSpread(_objectSpread({}, prev), {}, {
          getManualTaskDetailsReport: [].concat(_toConsumableArray(prev.getManualTaskDetailsReport), _toConsumableArray(fetchMoreResult.getManualTaskDetailsReport))
        });
      }
    });
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, manualTimeLoading ? /*#__PURE__*/React.createElement(Loader, null) : manualTimeError ? /*#__PURE__*/React.createElement("div", {
    className: "common-err-refresh-text"
  }, "Something went wrong, please refresh the page.") : userActive.length == 0 && projectActive.length == 0 ? /*#__PURE__*/React.createElement("div", {
    className: "no-data"
  }, "Please select a member or project") : !(manualTimeData !== null && manualTimeData !== void 0 && (_manualTimeData$getMa4 = manualTimeData.getManualTaskDetailsReport) !== null && _manualTimeData$getMa4 !== void 0 && _manualTimeData$getMa4.length) ? /*#__PURE__*/React.createElement("div", {
    className: "no-data"
  }, "No manual time found for this selection.") : /*#__PURE__*/React.createElement(TableGrid, {
    columns: columns,
    data: dataTable,
    handleLoadMore: handleLoadMore,
    isAllLoaded: isAllLoaded,
    isLoadingMore: isLoadingMore,
    userActive: userActive
  }));
};
var TableGrid = function TableGrid(props) {
  var columns = props.columns,
    data = props.data,
    handleLoadMore = props.handleLoadMore,
    isAllLoaded = props.isAllLoaded,
    isLoadingMore = props.isLoadingMore,
    userActive = props.userActive;
  var _useTable = useTable({
      columns: columns,
      data: data
    }, useSortBy),
    getTableProps = _useTable.getTableProps,
    getTableBodyProps = _useTable.getTableBodyProps,
    headerGroups = _useTable.headerGroups,
    rows = _useTable.rows,
    prepareRow = _useTable.prepareRow;
  return /*#__PURE__*/React.createElement("div", {
    className: "daily-attendance-content"
  }, /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("table", _extends({}, getTableProps(), {
    className: "daily-attendance-table"
  }), /*#__PURE__*/React.createElement("thead", null, headerGroups.map(function (headerGroup) {
    return /*#__PURE__*/React.createElement("tr", headerGroup.getHeaderGroupProps(), headerGroup.headers.map(function (column) {
      return /*#__PURE__*/React.createElement("th", column.getHeaderProps(column.getSortByToggleProps()), column.render("Header"), /*#__PURE__*/React.createElement("span", null, column.isSorted ? column.isSortedDesc ? /*#__PURE__*/React.createElement(HiChevronUp, {
        className: "app-usage-datas-thead-sort-icon"
      }) : /*#__PURE__*/React.createElement(HiChevronDown, {
        className: "app-usage-datas-thead-sort-icon"
      }) : /*#__PURE__*/React.createElement(HiOutlineSelector, {
        className: "app-usage-datas-thead-sort-icon"
      })));
    }));
  })), /*#__PURE__*/React.createElement("tbody", getTableBodyProps(), rows.map(function (row, i) {
    prepareRow(row);
    return /*#__PURE__*/React.createElement("tr", row.getRowProps(), row.cells.map(function (cell) {
      return /*#__PURE__*/React.createElement("td", cell.getCellProps(), cell.render("Cell"));
    }));
  }), !isAllLoaded ? /*#__PURE__*/React.createElement(React.Fragment, null, isLoadingMore ? /*#__PURE__*/React.createElement("tr", {
    className: "daily-attendance-table-load-more-tr"
  }, /*#__PURE__*/React.createElement("td", null), /*#__PURE__*/React.createElement("td", null), /*#__PURE__*/React.createElement("td", {
    colSpan: 6,
    className: "daily-attendance-table-load-more-td"
  }, /*#__PURE__*/React.createElement("div", {
    className: "task-tracker-load-more-button"
  }, /*#__PURE__*/React.createElement(Loader, null))), /*#__PURE__*/React.createElement("td", null), /*#__PURE__*/React.createElement("td", null), /*#__PURE__*/React.createElement("td", null)) : /*#__PURE__*/React.createElement("tr", {
    className: "daily-attendance-table-load-more-tr"
  }, /*#__PURE__*/React.createElement("td", null), /*#__PURE__*/React.createElement("td", null), /*#__PURE__*/React.createElement("td", {
    colSpan: 6,
    className: "daily-attendance-table-load-more-td"
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "outline-primary",
    onClick: function onClick() {
      handleLoadMore();
    },
    className: "daily-attendance-table-load-more-btn"
  }, "Load more")), /*#__PURE__*/React.createElement("td", null), /*#__PURE__*/React.createElement("td", null), /*#__PURE__*/React.createElement("td", null))) : userActive.length == 0 ? /*#__PURE__*/React.createElement("tr", {
    className: "daily-attendance-table-load-more-tr"
  }, /*#__PURE__*/React.createElement("td", null), /*#__PURE__*/React.createElement("td", null), /*#__PURE__*/React.createElement("td", {
    colSpan: 6,
    className: "daily-attendance-table-load-more-td"
  }, /*#__PURE__*/React.createElement("p", {
    className: "screenshot-load-more-button"
  }, "You have seen all the member")), /*#__PURE__*/React.createElement("td", null), /*#__PURE__*/React.createElement("td", null), /*#__PURE__*/React.createElement("td", null)) : null))));
};
export default ManualTimeReport;